import { connect } from 'react-redux';

import UserManager from './UserManager.js';

const ConnectedUserManager = connect()(UserManager);

export default ConnectedUserManager;
